import cloneDeep from 'lodash.clonedeep';

import * as ExperiencesClient from '../clients/experiences';
import { constants } from '../stores/SearchStore';

export default {
  search: {
    fetchSearchResults(filters, sort, currency) {
      const clonedFilters = cloneDeep(filters);

      this.dispatch(constants.FETCH_SEARCH, filters);
      ExperiencesClient.searchWithOthers(clonedFilters, sort, currency).then(
        (result) => {
          this.dispatch(constants.FETCH_SEARCH_SUCCESS, {
            result,
            filters: clonedFilters,
          });
          if (
            (result?.all?.hits?.hits?.length ?? 0) > 0 &&
            clonedFilters.page === 1
          ) {
            this.dispatch(constants.ADD_RECENT_SEARCH, {
              filters: clonedFilters,
            });
          }
        },
      );
    },
    fetchFamilyFriendlyList({ country, city, lang }) {
      this.dispatch(constants.FETCH_FAMILY_FRIENDLY_LIST, {
        country,
        city,
        lang,
      });
      ExperiencesClient.fetchFamilyFriendlyExperiences(country, city, lang)
        .then((result) =>
          this.dispatch(constants.FETCH_FAMILY_FRIENDLY_LIST_SUCCESS, {
            country,
            city,
            lang,
            result: result.relations.filter(
              (relation) => relation._type === 'experience',
            ),
          }),
        )
        .catch((error) => {
          this.dispatch(constants.FETCH_FAMILY_FRIENDLY_LIST_ERROR, {
            country,
            city,
            lang,
          });
          throw error;
        });
    },
    setSorting(sorting) {
      this.dispatch(constants.SET_SORTING, sorting);
    },
  },
};
